module.exports = __webpack_public_path__ + "images/2cdab0e22cae2d8a76546385371520b1.svg";